import { render, staticRenderFns } from "./AIChatWidgetTemplateGallery.vue?vue&type=template&id=ea7bf8f6&scoped=true"
import script from "./AIChatWidgetTemplateGallery.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetTemplateGallery.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetTemplateGallery.vue?vue&type=style&index=0&id=ea7bf8f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7bf8f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea7bf8f6')) {
      api.createRecord('ea7bf8f6', component.options)
    } else {
      api.reload('ea7bf8f6', component.options)
    }
    module.hot.accept("./AIChatWidgetTemplateGallery.vue?vue&type=template&id=ea7bf8f6&scoped=true", function () {
      api.rerender('ea7bf8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetTemplateGallery.vue"
export default component.exports